import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const PageLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center text-stone-400" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin" />
  </div>
);

export const RequireAuth = ({ roles, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to={`/masuk?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (!user.role) return <Navigate to="/pilih-peran" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
